import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { cancelIndication } from '../../actions/indicateInterest';
import { getOfferWatches } from '../../actions/offerWatches';

import './index.css';
import { offeringCategory } from '../../helpers/mappings';

class OfferWatches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelIndicationPending: {},
    };
  }
  async componentDidMount() {
    await this.props.getOfferWatches();
  }

  getAction(offerWatch, idx) {
    const { cancelIndicationPending } = this.state;
    let actionContent;
    if (!cancelIndicationPending[idx] && offerWatch.offer.status === 'active') {
      if (offerWatch.offer.category === offeringCategory.COMING_SOON.value ||
        offerWatch.offer.category === offeringCategory.TESTING_WATERS.value) {
        actionContent = (
          <button styleName="actionButton cancelButton" onClick={() => this.toggleCancelIndication(idx)}>Cancel Indication</button>
        );
      } else {
        actionContent = (
          <Link styleName="link" to={`/offers/${offerWatch.offer.id}`}>Go to offer to invest</Link>
        );
      }
    } else if (offerWatch.offer.status === 'closed') {
      actionContent = null;
    } else {
      actionContent = (
        <span styleName="promptContent">Are you sure? <button onClick={() => this.cancelIndication(offerWatch.offer.id, idx)} styleName="actionButton submitButton">Yes</button><button onClick={() => this.toggleCancelIndication()} styleName="actionButton submitButton">No</button></span>
      );
    }
    return actionContent;
  }

  toggleCancelIndication(idx) {
    const subState = {};
    subState[idx] = !this.state.cancelIndicationPending[idx];
    this.setState({ cancelIndicationPending: subState });
  }

  async cancelIndication(offeringId, idx) {
    await this.props.cancelIndication(offeringId);
    const subState = {};
    subState[idx] = !this.state.cancelIndicationPending[idx];
    this.setState({ cancelIndicationPending: subState });
  }

  render() {
    const { offeringWatches } = this.props;
    return (
      <div styleName="comingSoonOffersContainer">
        <div styleName="sectionTitle">
          Indications of Interest
        </div>
        {offeringWatches.map((offerWatch, idx) => {
          const offerStatus = offerWatch.offer.status === 'active' ? (
            <span styleName="activeStatus">Active</span>
          ) : (
            <span styleName="cancelButton">Closed</span>
          );
          return (
            <Fragment>
              <div styleName="card">
                <div styleName="offerNameHeader">
                  <Link to={`/offers/${offerWatch.offer.id}`}>{offerWatch.offer.name}</Link>
                </div>
                <div styleName="gridContainer">
                  <div styleName="gridItem">
                    <div styleName="cardHeader">Desired Investment Amount</div>
                    <div>{offerWatch.subscriberInvestmentRange}</div>
                  </div>
                  <div styleName="gridItem">
                    <div styleName="cardHeader">Status</div>
                    <div>{((offerWatch.offer.category === offeringCategory.COMING_SOON.value || offerWatch.offer.category === offeringCategory.TESTING_WATERS.value) && offerWatch.offer.status === 'active') ? 'Not Available Yet' : offerStatus}</div>
                  </div>
                  <div styleName="gridItem">
                    <div styleName="cardHeader" />
                    <div styleName="actionContent">{this.getAction(offerWatch, idx)}</div>
                  </div>
                </div>
              </div>
            </Fragment>
          );
        })}
        {offeringWatches.length === 0 ? (
          <div styleName="noDataSectionTitle">
            You have not indicated interest yet to any of the coming soon offerings.
          </div>
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = {
  getOfferWatches,
  cancelIndication,
};

const mapStateToProps = state => ({
  offeringWatches: get(state, 'offeringWatches.data', []),
  isFetching: get(state, 'offeringWatches.isFetching'),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferWatches);



// WEBPACK FOOTER //
// ./src/components/OfferWatches/index.js